module.exports = __webpack_public_path__ + "img/bt_filter_on_off.762bd4f7.svg";